import React, { FC } from 'react'
import { Col, Row, Typography } from 'antd'

const { Title, Paragraph } = Typography

interface HeaderProps {
  title: string
  description?: string | React.ReactNode
}

export const Header: FC<HeaderProps> = ({
  title,
  description
}) => {
  return (
    <Row justify={'center'} align={'middle'} 
    style={{
      textAlign: 'center'
    }}>
      <Col span={18}>
        <Title level={2}>
          {title}
        </Title>
        <Paragraph>
          {description}
        </Paragraph>
      </Col>
    </Row>
  )
}
